import ls from 'localstorage-slim'

import { Theme } from '@ankor-io/common/types/account'

/**
 * Toggle between light and dark mode
 * @param toMode Theme enum
 */
export const updateThemeMode = (toMode: Theme) => {
  ls.set('prefers-color-scheme', toMode)
  if (toMode === Theme.DARK) {
    document.documentElement.classList.add(Theme.DARK)
  } else {
    document.documentElement.classList.remove(Theme.DARK)
  }
}
